import React from 'react';
import { BadgeCheckIcon, BriefcaseIcon, BuildingIcon, CalendarIcon, ChartNoAxesColumnIcon, MegaphoneIcon, UsersIcon } from 'lucide-react';
import { OperatorShell } from './OperatorShell';
import type { NavGroup } from './OperatorShell';
import { Badge } from '../ui/Badge';
import { employerProfile, recruitmentMetrics } from '../../data/employer';
const GROUPS: NavGroup[] = [{
  label: 'Recruitment',
  items: [{
    to: '/employer',
    label: 'Listings',
    icon: BriefcaseIcon,
    end: true
  }, {
    to: '/employer/candidates',
    label: 'Candidates',
    icon: UsersIcon
  }]
}, {
  label: 'Campus presence',
  items: [{
    to: '/employer/campaigns',
    label: 'Campaigns',
    icon: MegaphoneIcon
  }, {
    to: '/employer/events',
    label: 'Events',
    icon: CalendarIcon
  }]
}, {
  label: 'Organisation',
  items: [{
    to: '/employer/analytics',
    label: 'Analytics',
    icon: ChartNoAxesColumnIcon
  }, {
    to: '/employer/company',
    label: 'Company profile',
    icon: BuildingIcon
  }]
}];
export function EmployerShell() {
  return <OperatorShell consoleKey="employer" consoleName="Employer console" scopeLine={`${employerProfile.name} · ${employerProfile.recruiter}`} groups={GROUPS} summary={<div data-id="element-5171" data-mp="2ya2yfmjohjwf">
          <p className="text-caption text-ink-muted" data-id="element-5172" data-mp="2y9kus4uos3eh">{recruitmentMetrics[0].label}</p>
          <p className="cz-num mt-1 text-h4 font-semibold text-ink" data-id="element-5173" data-mp="2kal7b0iwtujw">
            {recruitmentMetrics[0].value}
          </p>
          <Badge tone="ok" className="mt-2" icon={<BadgeCheckIcon className="h-3.5 w-3.5" data-id="element-5175" data-mp="2paprb0j117ev" />} data-id="element-5174" data-mp="2p9occkyw40rv">
            Verified employer
          </Badge>
        </div>} data-id="element-5170" data-mp="37zwa0njtlz0o" />;
}